import { render, staticRenderFns } from "./Administracion.vue?vue&type=template&id=1c3295cc&"
import script from "./Administracion.vue?vue&type=script&lang=js&"
export * from "./Administracion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports